/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateK12ContactRequestJobMutationRequest,
  CreateK12ContactRequestJobMutationResponse,
  CreateK12ContactRequestJob400,
} from '../types/CreateK12ContactRequestJob'

function getCreateK12ContactRequestJobUrl() {
  const res = { method: 'POST', url: `/api/v1/contact_request/k12/` as const }
  return res
}

/**
 * @summary Create a contact request job for K-12 districts
 * {@link /api/v1/contact_request/k12/}
 */
export async function createK12ContactRequestJob(
  data: CreateK12ContactRequestJobMutationRequest,
  config: Partial<RequestConfig<CreateK12ContactRequestJobMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateK12ContactRequestJobMutationResponse,
    ResponseErrorConfig<CreateK12ContactRequestJob400>,
    CreateK12ContactRequestJobMutationRequest
  >({
    method: 'POST',
    url: getCreateK12ContactRequestJobUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
